(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('AccessSearch', AccessSearch);

    AccessSearch.$inject = ['$resource'];

    function AccessSearch($resource) {
        var resourceUrl =  'api/_search/accesses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
